// extracted by mini-css-extract-plugin
export default {"content":"ModalSkeleton_content__408ps","headingText":"ModalSkeleton_headingText__sGMhq","message":"ModalSkeleton_message__QxDww"};